import ReactDOM from 'react-dom';
import Routes from './routes';
import 'semantic-ui-css/semantic.min.css'

ReactDOM.render(
  (<Routes/>),
  document.getElementById('root')
);
